<!-- 组件说明 -->
<template>
  <div class="rich_text" :style="richTextStyle" v-html="data.data"></div>
</template>

<script>
export default {
  components: {},
  props: ['data'],
  data() {
    return {};
  },
  computed: {
    richTextStyle() {
      return `padding:${this.$px2rem(this.data.prop.padding)}rem;backgroundColor:${
        this.data.prop.backgroundColor == null ? '#00000000' : this.data.prop.backgroundColor
      }`;
    },
  },
  methods: {},
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.rich_text {
  display: block;
  margin: 0;
  padding: 0;
  height: auto;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/RichText.vue